/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddNftGroupingBody
 */
export interface AddNftGroupingBody {
    /**
     * 
     * @type {string}
     * @memberof AddNftGroupingBody
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof AddNftGroupingBody
     */
    sortPriority?: number;
    /**
     * 
     * @type {string}
     * @memberof AddNftGroupingBody
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof AddNftGroupingBody
     */
    discordUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof AddNftGroupingBody
     */
    twitterUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof AddNftGroupingBody
     */
    websiteUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof AddNftGroupingBody
     */
    hero?: string;
    /**
     * 
     * @type {string}
     * @memberof AddNftGroupingBody
     */
    icon?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AddNftGroupingBody
     */
    categories?: Array<string>;
}

/**
 * Check if a given object implements the AddNftGroupingBody interface.
 */
export function instanceOfAddNftGroupingBody(value: object): value is AddNftGroupingBody {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function AddNftGroupingBodyFromJSON(json: any): AddNftGroupingBody {
    return AddNftGroupingBodyFromJSONTyped(json, false);
}

export function AddNftGroupingBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddNftGroupingBody {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'sortPriority': json['sortPriority'] == null ? undefined : json['sortPriority'],
        'description': json['description'] == null ? undefined : json['description'],
        'discordUrl': json['discordUrl'] == null ? undefined : json['discordUrl'],
        'twitterUrl': json['twitterUrl'] == null ? undefined : json['twitterUrl'],
        'websiteUrl': json['websiteUrl'] == null ? undefined : json['websiteUrl'],
        'hero': json['hero'] == null ? undefined : json['hero'],
        'icon': json['icon'] == null ? undefined : json['icon'],
        'categories': json['categories'] == null ? undefined : json['categories'],
    };
}

export function AddNftGroupingBodyToJSON(json: any): AddNftGroupingBody {
    return AddNftGroupingBodyToJSONTyped(json, false);
}

export function AddNftGroupingBodyToJSONTyped(value?: AddNftGroupingBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'sortPriority': value['sortPriority'],
        'description': value['description'],
        'discordUrl': value['discordUrl'],
        'twitterUrl': value['twitterUrl'],
        'websiteUrl': value['websiteUrl'],
        'hero': value['hero'],
        'icon': value['icon'],
        'categories': value['categories'],
    };
}

